import { useCurrentLocale } from '../contexts/CurrentLanguageContext'
import { getRegionsForLocale } from '../model/region'

export const useRegions = () => {
	const locale = useCurrentLocale()
	return getRegionsForLocale(locale)
}
